// Zod 4's JIT compiler uses `new Function()`, which violates our CSP `script-src 'self'` policy.
// Disabling JIT must happen before any module that creates a zod schema is loaded.
// Using a dynamic import for the bootstrap module ensures all transitive dependencies
// (which may call z.object() at module scope) are evaluated AFTER jitless is set.
import { handleBootstrapError } from "@fideus/chunk-error-recovery";
import { config } from "zod";

config({ jitless: true });

// biome-ignore lint/suspicious/noConsole: intentional user-facing console messages
console.log(
  "%c\n  🔒 Security researcher? %c\n  Check https://www.fideus.de/.well-known/security.txt\n",
  "font-size:14px;font-weight:bold;color:#1a73e8;",
  "font-size:13px;color:#555;"
);
// biome-ignore lint/suspicious/noConsole: intentional user-facing console messages
console.log(
  "%c\n  🚀 Looking for an awesome job? %c\n  Check https://www.fideus.de/karriere\n",
  "font-size:14px;font-weight:bold;color:#1a73e8;",
  "font-size:13px;color:#555;"
);

void import("./bootstrap").catch(handleBootstrapError);
